export default __webpack_public_path__ + "static/playtika-thumbnail-5e636ad0ceb2fdd1e3417c3361850cdd.webp";